import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import Image from 'src/elements/image/image';
import Paragraph from 'src/elements/typography/paragraph';
import { Divider, HighlightMetric, HighlightMetricsContainer } from './caseStudies.highlightMetrics.styles';

interface HighlightMetricsProps {
  launchDate: string;
  members: string;
  pricing: string;
}

const HighlightMetrics = ({ pricing, launchDate, members }: HighlightMetricsProps): JSX.Element => {
  const icons: any = useStaticQuery(graphql`{
    rocketIcon: contentfulAsset(contentful_id: {eq: "5sEIvO5PUDEVuerAiZOxzz"}) {
      gatsbyImageData(width: 46, height: 46,  layout: FIXED, placeholder: BLURRED)
    }
    handsIcon: contentfulAsset(contentful_id: {eq: "TwvschkaWQm7LsVCn5P5L"}) {
      gatsbyImageData(width: 46, height: 46,  layout: FIXED, placeholder: BLURRED)
    }
    moneyIcon: contentfulAsset(contentful_id: {eq: "f4jaTvKMdABI40xlTsmjr"}) {
      gatsbyImageData(width: 46, height: 46,  layout: FIXED, placeholder: BLURRED)
    }
  }
  `)

  return (
    <HighlightMetricsContainer>
      <HighlightMetric>
        <Image childImageSharp={icons.rocketIcon.gatsbyImageData} alt="Rocket"/>
        <div>
          {
            launchDate.split('\n')
              .filter(s => !!s).map((text, index) => (
                <Paragraph key={index}
                  text={text.trimRight()}
                  size="1.5em"
                  sizeSubLg="1.125em"
                  sizeSubMd="0.875em"
                  align="center"
                  weight="light"
                />
              ))
          }
        </div>
      </HighlightMetric>
      <Divider />
      <HighlightMetric>
        <Image childImageSharp={icons.handsIcon.gatsbyImageData} alt="Hands"/>
        <div>
          {
            members.split('\n')
              .filter(s => !!s).map((text, index) => (
                <Paragraph key={index}
                  text={text.trimRight()}
                  size="1.5em"
                  sizeSubLg="1.125em"
                  sizeSubMd="0.875em"
                  align="center"
                  weight="light"
                />
              ))
          }
        </div>
      </HighlightMetric>
      <Divider />
      <HighlightMetric>
        <Image childImageSharp={icons.moneyIcon.gatsbyImageData} alt="Hands"/>
        <div>
          {
            pricing.split('\n')
              .filter(s => !!s).map((text, index) => (
                <Paragraph key={index}
                  text={text.trimRight()}
                  size="1.5em"
                  sizeSubLg="1.125em"
                  sizeSubMd="0.875em"
                  align="center"
                  weight="light"
                />
              ))
          }
        </div>
      </HighlightMetric>
    </HighlightMetricsContainer>
  )
}

export default HighlightMetrics;
